export default {"src":"https://static.smartdeer.com/global/mkt/_next/static/media/work-type.d1272393.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};